// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_show_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Show filters`
};

const el_show_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Φίλτρα`
};

const ru_show_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Фильтры`
};

const he_show_filters = /** @type {(inputs: {}) => string} */ () => {
	return `מסננים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show_filters", locale)
	if (locale === "en") return en_show_filters(inputs)
	if (locale === "el") return el_show_filters(inputs)
	if (locale === "ru") return ru_show_filters(inputs)
	if (locale === "he") return he_show_filters(inputs)
	return "show_filters"
};